import { Shield, Users, Building2 } from 'lucide-react';

const pillars = [
  {
    icon: Users,
    title: 'Our Own Crew',
    description: 'Our own crew pulls the cable and fiber and mounts the cameras and door hardware. One team for cabling, cameras, door access and Wi-Fi, and every cable run is tested before handover.',
    accent: 'text-cobalt-400',
    bg: 'bg-cobalt-500/10',
  },
  {
    icon: Building2,
    title: 'Commercial Work Only',
    description: 'We work for businesses across the Treasure Valley, from Meridian and Boise to Nampa and Eagle. We are Certified UniFi installers.',
    accent: 'text-emerald-400',
    bg: 'bg-emerald-500/10',
  },
  {
    icon: Shield,
    title: 'BBB A+ Accredited Since 2020',
    description: 'BBB Accredited Business since 2020 with an A+ rating, listed by the BBB as a Low Voltage Contractor.',
    accent: 'text-yellow-400',
    bg: 'bg-yellow-500/10',
  },
];

export function ValuePillars() {
  return (
    <section className="py-16 bg-navy-950 border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {pillars.map((pillar) => {
            const Icon = pillar.icon;
            return (
              <div
                key={pillar.title}
                className="text-center p-8 rounded-2xl border border-white/10 bg-white/5"
              >
                <div className={`inline-flex p-4 rounded-xl ${pillar.bg} mb-4`}>
                  <Icon className={`w-8 h-8 ${pillar.accent}`} />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{pillar.title}</h3>
                <p className="text-gray-300 text-sm leading-relaxed">{pillar.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
